<template>
  <div class="panel text-left">
    <div :class="['loading-area', saving ? 'loading' : '']">
      <div :class="['loading-area__content', saving ? 'loading' : '']">
        <div class="panel__header">
          <h3 class="panel__title">Vendor Portal Configuration</h3>
        </div>

        <!--        <div class="form-field">-->
        <!--          <div class="grid-x grid-padding-x">-->
        <!--            <div class="cell large-4">-->
        <!--              <label>Disabled<span-->
        <!--                data-tooltip-->
        <!--                tabindex="1"-->
        <!--                title="This will disable the Portal completely."-->
        <!--              ><i class="fas fa-question-circle"></i-->
        <!--              ></span></label>-->
        <!--            </div>-->

        <!--            <div class="cell small-shrink medium-auto">-->
        <!--              <checkbox @check="check('vendor_portal_disabled')"-->
        <!--                        :active="$store.state.metas.vendor_portal_disabled.meta_value !== null ? $store.state.metas.vendor_portal_disabled.meta_value : false"></checkbox>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Portal Theme</label>
            </div>

            <div class="cell auto">
              <label
                :class="['radio-choice', $store.state.metas.vendor_portal_theme.meta_value === 'light' || $store.state.metas.vendor_portal_theme.meta_value === '' ? 'active' : '']"
                for="portal-theme-light" style="background: #fff; color: #333;"
                @click.self="portalTheme('light')">Light
                <input id="portal-theme-light" class="hidden" type="radio" name="theme"
                       value="light">
              </label>

              <label
                :class="['radio-choice', $store.state.metas.vendor_portal_theme.meta_value === 'dark' ? 'active' : '']"
                for="portal-theme-dark" style="background: #333; color: #fff;"
                @click.self="portalTheme('dark')">Dark
                <input id="portal-theme-dark" class="hidden" type="radio" name="theme"
                       value="dark" checked="checked">
              </label>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Logo Url
                <span
                  data-tooltip
                  tabindex="1"
                  title="Store name will be used if no logo is set."
                ><i class="fas fa-question-circle"></i
                ></span>
              </label>
            </div>

            <div class="cell auto">
              <input
                id="logo"
                name="logo"
                type="text"
                :value="$store.state.metas.vendor_portal_logo_url.meta_value !== '' ? $store.state.metas.vendor_portal_logo_url.meta_value : ''"
                :placeholder="'https://' + $store.state.shop.myshopify_domain + '/'"
              />
              <p><small><i>For logo to show up on Invoices it will need to be in PNG or JPEG format.</i></small></p>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Shop Title
                <span
                  data-tooltip
                  tabindex="1"
                  title="Displays if no logo is added. Defaults to store name in Shopify."
                ><i class="fas fa-question-circle"></i
                ></span>
              </label>
            </div>

            <div class="cell auto">
              <input
                id="logo-title"
                name="logo-title"
                type="text"
                :value="$store.state.metas.vendor_portal_logo_title.meta_value !== '' ? $store.state.metas.vendor_portal_logo_title.meta_value : ''"
                :placeholder="$store.state.shop.name"
              />
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Primary Color</label>
            </div>

            <div class="cell auto">
              <input id="primary-color" class="short-input" type="color"
                     :value="$store.state.metas.vendor_portal_primary_color.meta_value !== '' ? $store.state.metas.vendor_portal_primary_color.meta_value : '#eb008c'">
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Secondary Color</label>
            </div>

            <div class="cell auto">
              <input id="secondary-color" class="short-input" type="color"
                     :value="$store.state.metas.vendor_portal_secondary_color.meta_value !== '' ? $store.state.metas.vendor_portal_secondary_color.meta_value : '#7101a5'">
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Login Font Color</label>
            </div>

            <div class="cell auto">
              <input id="font-color" class="short-input" type="color"
                     :value="$store.state.metas.vendor_portal_font_color.meta_value !== '' ? $store.state.metas.vendor_portal_font_color.meta_value : '#333333'">
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Button Text Color</label>
            </div>

            <div class="cell auto">
              <input id="button-text-color" class="short-input" type="color"
                     :value="$store.state.metas.vendor_portal_button_text_color.meta_value !== '' ? $store.state.metas.vendor_portal_button_text_color.meta_value : '#ffffff'">
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Login Description
                <span
                  data-tooltip
                  tabindex="1"
                  title="This will appear on the login screen."
                ><i class="fas fa-question-circle"></i
                ></span>
              </label>
            </div>

            <div class="cell auto">
              <textarea id="login-description" rows="6" :value="$store.state.metas.vendor_portal_login_description.meta_value !== '' ? $store.state.metas.vendor_portal_login_description.meta_value : ''"></textarea>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label for="login-title">Login Title</label>
            </div>

            <div class="cell auto">
              <input
                id="login-title"
                name="login-title"
                type="text"
                :value="$store.state.metas.vendor_portal_login_title.meta_value !== '' ? $store.state.metas.vendor_portal_login_title.meta_value : ''"
                placeholder="Welcome Vendors"
              />
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label for="terms">Link to Terms & Conditions <span
                data-tooltip
                tabindex="1"
                title="Will require acceptance of terms before registration."
              ><i class="fas fa-question-circle"></i
              ></span></label>
            </div>

            <div class="cell auto">
              <input
                id="terms"
                name="terms"
                type="text"
                :value="$store.state.metas.vendor_portal_terms.meta_value !== '' ? $store.state.metas.vendor_portal_terms.meta_value : ''"
              />
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label for="css">Custom CSS <span
                data-tooltip
                tabindex="1"
                title="Will add your custom css to the vendor portal."
              ><i class="fas fa-question-circle"></i
              ></span></label>
            </div>

            <div class="cell auto">
              <textarea
                id="css"
                name="css"
                type="text"
                rows="10"
                :value="$store.state.metas.vendor_portal_css.meta_value !== '' ? $store.state.metas.vendor_portal_css.meta_value : ''"
              />
            </div>
          </div>
        </div>

        <hr>

        <!--          <button @click="updateCommissionFields">Update Commission Fields</button>-->

        <!--          <transition name="fade">-->
        <!--              <edit-commission-fields v-if="updatingCommissionFields"-->
        <!--                              @done="closeUpdateCommissionFields"/>-->
        <!--          </transition>-->

        <h6>Visible Commission Details</h6>
        <p>By unchecking these fields they will hide the details to the vendor.</p>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Products</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_portal_products')"
                        :active="$store.state.metas.vendor_portal_products.meta_value !== '' ? $store.state.metas.vendor_portal_products.meta_value : true"></checkbox>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Commission</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_field_commissions')"
                        :active="$store.state.metas.vendor_field_commissions.meta_value !== '' ? $store.state.metas.vendor_field_commissions.meta_value : true"></checkbox>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Sell Price</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_field_sell_price')"
                        :active="$store.state.metas.vendor_field_sell_price.meta_value !== '' ? $store.state.metas.vendor_field_sell_price.meta_value : true"></checkbox>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Discount</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_field_discount')"
                        :active="$store.state.metas.vendor_field_discount.meta_value !== '' ? $store.state.metas.vendor_field_discount.meta_value : true"></checkbox>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Order #</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_field_order_num')"
                        :active="$store.state.metas.vendor_field_order_num.meta_value !== '' ? $store.state.metas.vendor_field_order_num.meta_value : true"></checkbox>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Order Date</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_field_order_date')"
                        :active="$store.state.metas.vendor_field_order_date.meta_value !== '' ? $store.state.metas.vendor_field_order_date.meta_value : true"></checkbox>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Customer Name</label>
            </div>

            <div class="cell small-shrink medium-auto">
              <checkbox @check="check('vendor_field_customer_name')"
                        :active="$store.state.metas.vendor_field_customer_name.meta_value !== '' ? $store.state.metas.vendor_field_customer_name.meta_value : false"></checkbox>
            </div>
          </div>
        </div>

        <div class="text-success-color text-right" v-if="success">Vendor
          portal settings have been saved.
        </div>

        <div class="text-alert-color text-right" v-if="error">There was an
          error saving. Please try again later.
        </div>
      </div>

      <div class="panel__footer text-right">
        <button @click="savePortal">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import checkbox from '../../globals/checkbox'
import EditCommissionFields from '../../globals/editCommissionFields.vue'

export default {
  name: 'vendorPortalSettings',
  components: {EditCommissionFields, checkbox},
  mixins: [
    client
  ],
  data: function () {
    return {
      'saving': false,
      'success': false,
      'error': false,
      'updatingCommissionFields': false
    }
  },
  // computed: {
  settings () {
    return this.$store.state.settings
  },
  metas () {
    return this.$store.state.metas
  },
  methods: {
    closeUpdateCommissionFields () {
      this.updatingCommissionFields = false
    },
    updateCommissionFields () {
      this.updatingCommissionFields = true
    },
    check (field) {
      this.$store.state.metas[field].meta_value = !this.$store.state.metas[field].meta_value
    },
    portalTheme (theme) {
      this.$store.state.metas.vendor_portal_theme.meta_value = theme
    },
    async savingPortal () {
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_theme)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_field_commissions)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_field_sell_price)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_field_discount)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_field_order_num)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_field_order_date)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_products)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_disabled)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_primary_color)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_secondary_color)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_font_color)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_button_text_color)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_login_description)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_login_title)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_logo_url)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_logo_title)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_field_customer_name)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_terms)
      await this.$store.dispatch('updateMeta', this.$store.state.metas.vendor_portal_css)

      this.success = true
      this.saving = false
    },
    savePortal () {
      let primaryColor = document.getElementById('primary-color').value
      let secondaryColor = document.getElementById('secondary-color').value
      let fontColor = document.getElementById('font-color').value
      let buttonTextColor = document.getElementById('button-text-color').value
      let logo = document.getElementById('logo').value
      let loginDescription = document.getElementById('login-description').value
      let loginTitle = document.getElementById('login-title').value
      let logoTitle = document.getElementById('logo-title').value
      let terms = document.getElementById('terms').value
      let css = document.getElementById('css').value

      this.$store.state.metas.vendor_portal_primary_color.meta_value = primaryColor
      this.$store.state.metas.vendor_portal_secondary_color.meta_value = secondaryColor
      this.$store.state.metas.vendor_portal_font_color.meta_value = fontColor
      this.$store.state.metas.vendor_portal_button_text_color.meta_value = buttonTextColor
      this.$store.state.metas.vendor_portal_logo_url.meta_value = logo
      this.$store.state.metas.vendor_portal_login_description.meta_value = loginDescription
      this.$store.state.metas.vendor_portal_login_title.meta_value = loginTitle
      this.$store.state.metas.vendor_portal_logo_title.meta_value = logoTitle
      this.$store.state.metas.vendor_portal_terms.meta_value = terms
      this.$store.state.metas.vendor_portal_css.meta_value = css

      this.saving = true
      this.savingPortal()
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/settings/portal.vue